import React from "react";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import logo from "../../assets/Logo.webp"; // Main logo
import logotext from "../../assets/logo-text-only.webp"; // Text logo

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Brand with Logo and Logo-text-only */}
          <div className="footer-brand">
            <NavLink to="/" className="footer-logo">
              <img src={logo} alt={t("footer.brand.labName")} className="footer-logo-img" />
              <img src={logotext} alt={t("footer.brand.labName")} className="footer-logo-text" />
            </NavLink>
            <h2 className="footer-talk">{t("footer.brand.tagline")}</h2>
            <a href={`mailto:${t("footer.brand.email")}`} className="footer-email">
              {t("footer.brand.email")}
            </a>
          </div>

          {/* Links */}
          <div className="footer-links">
            {/* Section 2 - Legal */}
            <div className="footer-section">
              <h3>{t("footer.legalSection.title")}</h3>
              <ul>
                <li><a href="/privacy">{t("footer.legalSection.privacyPolicy")}</a></li>
                <li><a href="/terms">{t("footer.legalSection.terms")}</a></li>
              </ul>
            </div>

            {/* Section 3 - Social */}
            <div className="footer-section">
              <h3>{t("footer.socialSection.title")}</h3>
              <ul>
                <li>
                  <a href="https://discord.gg/zenitailab" target="_blank" rel="noopener noreferrer">
                    {t("footer.socialSection.discord")}
                  </a>
                </li>
                <li>
                  <a href="https://linkedin.com/company/zenitailab" target="_blank" rel="noopener noreferrer">
                    {t("footer.socialSection.linkedin")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          {t("footer.copyright", { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  );
};

export default Footer;